import React, { useState, useEffect } from 'react';
import { Form , Field, FormElement, FieldWrapper} from "@progress/kendo-react-form"
import SubHeader from "../components/SubHeader"
import { CusFormLabel, FormSubTitle, FormTitle, CusFormInput, CusFormComboBox, TermsFormCheckboxNoErrMsgDisplay } from "../validation/Form-Components"
import taxData from '../data/taxdetailsdata.json'
import FormContainer from "../components/FormContainer"
import CusRadioButton from '../components/CusRadioButton'
import { reqDDLValidator, termsValidator, tinValidator } from '../validation/Validators'
import config from '../appconfig/config.json'
import CusProgressBar from '../components/CusProgressBar';
import service from '../services/ApiService.js';
import { useHistory } from "react-router-dom";
import TaxResidence from '../components/TaxResidence';
import Loading from '../components/Loading';
import countries from '../data/domicilecountries.json';
import uploadConfig from '../data/uploaddetailsdata.json';
import storage from '../factory/StorageFactory';
import CusToast from '../components/CusToast';
import helper from '../factory/Helper.js';
 
let couOfResiObj = {},couOfResiObj3 = {}; 
let defTin = '';
 
const NSTaxDetails = (props) => {

    let timer;
    const history = useHistory();
    const seq0='0', seq1='1',seq2='2',seq3='3';
    const detailsType='6';
    const item = { bgcolor: "#389A6E", completed: 70 };
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const defCountry = {value:"SG","label":"SINGAPORE"}; //default is singapore

    // const countryArray = taxData.topCountry.concat(countries);
 
    
    const [payTaxSGOnlySelected,setPayTaxSGOnlySelected] = useState('Y');
    const [isAboveTINSelected, setIsAboveTINSelected] = useState('Y');
    const [showAddBtn, setShowAddBtn] = useState(true);

    const [selectedIsActiveBizEntity,setSelectedIsActiveBizEntity] = useState(null);
    const [selectedFATCAUS,setSelectedFATCAUS] = useState(null);

    const [response,setResponse] = useState({
        CompDtls:{}, 
        ApplicantDtls:[],
        ApplicantsDtlsMyInfo:{}
    })
    
    const [taxDetails,setTaxDetails] = useState({
        CouOfTaxRes:defCountry.label, //default SG for Sole
        TIN: defTin,
        PayTaxSGOnly:'', 
    
        TaxNumber2:'',
        CouOfTaxRes2:'',
        AbleProvTIN2:'',
        ReasonUnableProvTIN2:'',

        TaxNumber3:'',
        CouOfTaxRes3:'',
        AbleProvTIN3:'',
        ReasonUnableProvTIN3:'',

        CRSStatus:'',
        FATCABIZ:'',

        TaxClare:false
    })

    useEffect(() => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }

        window.scrollTo(0,0);
        // countries.sort(helper.dynamicSort('label'));
        couOfResiObj={}; couOfResiObj3={};
        defTin = '';
       
        getData();  
        return () => clearTimeout(timer);
    }, []);

    const handleSubmit = (eve) => { 

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }

        if(eve.isValid){
            let data = JSON.parse(JSON.stringify(eve.values));
            if(validateFATCA(data)){
               saveTaxDetails(formatJsonParams(data));
            }
        }
    }

    const getData = () => {
        service.get().then( res => {
            if(res.data.isSucess) {
                setResponse(res.data.model.fields.request);
                bindFormData(res.data.model.fields.request);
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
          
            setIsLoading(false);
        })
    }

   

    const bindFormData = (data) => {
        let crsStatus = '';
    
        try {
            setPayTaxSGOnlySelected(data.TaxStatus.PayTaxSGOnly !== null? data.TaxStatus.PayTaxSGOnly:'Y');
            setIsAboveTINSelected(data.TaxStatus.IsAboveTIN !== null? data.TaxStatus.IsAboveTIN:'Y');

            crsStatus=data.CRSFATCA.IsActiveBizEntity !== null? data.CRSFATCA.IsActiveBizEntity:'Y';
            setSelectedIsActiveBizEntity(data.CRSFATCA.IsActiveBizEntity !== null? data.CRSFATCA.IsActiveBizEntity:'Y');
            setSelectedFATCAUS(data.CRSFATCA.FATCAUS !== null? data.CRSFATCA.FATCAUS:'N');

            let firstResiObj = {}, secResiObj = {};
            let idx = 0; 
            defTin = data.TaxStatus.TIN !== null? data.TaxStatus.TIN:data.CompDtls.RegNo;

            if(data.TaxStatus && data.CRSFATCA) {
                if(data.TaxStatus.ApplicantTIN) {
                    if(data.TaxStatus.ApplicantTIN.length === undefined) {
                        firstResiObj = data.TaxStatus.ApplicantTIN;
                    }
                    else{
                        idx = data.TaxStatus.ApplicantTIN.length;
                    }
                } 
                if(idx === 1) {
                     firstResiObj = data.TaxStatus.ApplicantTIN[0];
                }
                else if(idx === 2){
                    setShowAddBtn(false);
                    firstResiObj = data.TaxStatus.ApplicantTIN[0];
                    secResiObj =data.TaxStatus.ApplicantTIN[1];
                }

                setTaxDetails({
                    CouOfTaxRes:defCountry.label, //default SG for Sole
                    TIN: defTin,  //default NRIC
                    PayTaxSGOnly:data.TaxStatus.PayTaxSGOnly, //nric from local storage
                    
                    TaxClare:getBindTaxClare(data) === 'true'? true:false,
            
                    TaxNumber2:firstResiObj.TaxNumber,
                    CouOfTaxRes2:getObjInArray(firstResiObj.CouOfTaxRes,filterArray(countries,defCountry.value)),
                    AbleProvTIN2:getObjInArray(firstResiObj.AbleProvTIN,taxData.ableToProvideTinDDL.data),
                    ReasonUnableProvTIN2:firstResiObj.ReasonUnableProvTIN,
            
                    TaxNumber3:secResiObj.TaxNumber,
                    CouOfTaxRes3:getObjInArray(secResiObj.CouOfTaxRes,filterArray(countries,defCountry.value)),
                    AbleProvTIN3:getObjInArray(secResiObj.AbleProvTIN,taxData.ableToProvideTinDDL.data),
                    ReasonUnableProvTIN3:secResiObj.ReasonUnableProvTIN,

                    CRSStatus:data.CRSFATCA.CRSStatus !==null? getObjInArray(data.CRSFATCA.CRSStatus,getCRSStatusArrayByResStatus(crsStatus)):'',
                    FATCABIZ:data.CRSFATCA.FATCABIZ !==null? getObjInArray(data.CRSFATCA.FATCABIZ,taxData.fatcaBizStatus):'',
                })
            }
            setIsLoading(false);
        }catch(ex){
         
            setIsLoading(false);
        }
      
    }

    const getBindTaxClare = (data) => {
        return data.TaxClare.AuthPerSeq0;
    }

    const getObjInArray = (iValue, array) => {
        const result = array.find( ({ value }) => value === iValue);
        return result;
    }

    

    const validateFATCA = (data) => {
  
        let valid=true;
        if(payTaxSGOnlySelected === ''){
            showErrMsg(config.error.RdoOption+' (Please select "Does your business pay tax to Singapore only")');
        }
        else if(isAboveTINSelected === ''){
            showErrMsg(config.error.RdoOption+' (Please select Is the above your TIN)');
        }
        else if(selectedIsActiveBizEntity === null || selectedIsActiveBizEntity === null){
            showErrMsg(config.error.RdoOption+' (FATCA)');
            valid = false;
        }
        else if(data.AbleProvTIN2 && data.AbleProvTIN2.value === 'Y') {
            if(data.TaxNumber2 === undefined || data.TaxNumber2.length === 0){
                showErrMsg('Input the blank field (Tax Identification Number (TIN))');
                valid = false;
            }
        }
        else if(data.AbleProvTIN3 && data.AbleProvTIN3.value === 'Y') {
            if(data.TaxNumber3 === undefined || data.TaxNumber3.length === 0){
                showErrMsg('Input the blank field (Tax Identification Number (TIN))');
                valid = false;
            }
        }
        else {
            valid = true;
        }
        return valid;
    }
    
    const saveTaxDetails = (params) =>{
       setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess){
                goNext();
            }
            else{
                showErrMsg(config.error.SaveApiFailed);
            }      
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            routeUploadDtlsbyType();
        }
    }

    const routeUploadDtlsbyType = () => {
        let uploadDtlsType = storage.getCompType();
        if(uploadDtlsType === uploadConfig.SCOType.SCO2) {
            history.push(config.route.LLPUploadDetails);
        }
        else if(uploadDtlsType === uploadConfig.SCOType.SCO3) {
            history.push(config.route.ACSUploadDetails);
        }
        else {  // SCO1, SCO4
            history.push(config.route.NSUploadDetails);
        }
    }
    
    let formatJsonParams = function(data) {

        let applicantObj = {}
        let applicantArray = [];

        if(payTaxSGOnlySelected === 'N') {
            applicantObj = {
                Order:1,
                NRIC:response.CompDtls.RegNo,   //store nric
                TaxNumber: data.TaxNumber2,
                CouOfTaxRes:data.CouOfTaxRes2.value,
                AbleProvTIN:data.AbleProvTIN2.value,
                ReasonUnableProvTIN:data.ReasonUnableProvTIN2
            }
            applicantArray.push(applicantObj);
        }

        if(!showAddBtn){
            applicantObj = {
                Order:2,
                NRIC:response.CompDtls.RegNo,   //store nric
                TaxNumber: data.TaxNumber3,
                CouOfTaxRes:data.CouOfTaxRes3.value,
                AbleProvTIN:data.AbleProvTIN3.value,
                ReasonUnableProvTIN:data.ReasonUnableProvTIN3
            }
            applicantArray.push(applicantObj);
        }

        let params={
            TaxStatus:{
                TIN:data.TIN,
                CouOfTaxRes:'SG', //default SG
                PayTaxSGOnly:payTaxSGOnlySelected,
                ApplicantTIN: applicantArray
            }, 
            CRSFATCA:{
                IsActiveBizEntity:selectedIsActiveBizEntity,
                CRSStatus:data.CRSStatus.value,
                FATCAUS:selectedFATCAUS,
                FATCABIZ:data.FATCABIZ.value,

                FATCAUSC:'',
                FATCAUSPR:'',
                FATCAUSR:'',
                FATCANUSP:''
            },
            TaxClare: formatTaxClare()
        }
        return params;
    }

    const formatTaxClare = (taxClare) => {
        let params = {
            AuthPerSeq0:true,
            AuthPerSeq1:false,
            AuthPerSeq2:false,
            AuthPerSeq3:false
        };

        return params;
    }

    const filterArray =(data, fValue) =>{
        
        const fArray = data.filter( d => d.value !== fValue);
        return fArray;
    }

    const handleCRSStatus = (e) =>{

    }

    const handleFATCABiz = (e) =>{
        
    }

    const getCRSStatusArray = () => {
 
        if(selectedIsActiveBizEntity === 'N') {
            return taxData.crsStatusNo;
        }
        else {
     
            return taxData.crsStatusYes;
        }
    }

    const getCRSStatusArrayByResStatus = (status) => {
 
        if(status === 'N') {
           
            return taxData.crsStatusNo;
        }
        else {
      
            return taxData.crsStatusYes;
        }
    }
 

    const handleFATCAUSChange = (e) => {
        setSelectedFATCAUS(e.value)
    }

    
    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const showReasonUnableProvTIN2 = () =>{
 
        if(taxDetails.AbleProvTIN2){
            if(taxDetails.AbleProvTIN2.value === taxData.ableToProvideTinDDL.data[2].value){
          
                return true;
            }
        }
        return false;
    }

    const showReasonUnableProvTIN3 = () =>{
 
        if(taxDetails.AbleProvTIN3 !== undefined){
            if(taxDetails.AbleProvTIN3.value === taxData.ableToProvideTinDDL.data[2].value){
                return true;
            }
        }
        return false;
    }

    const getLoginUserOrder = (resObj) => {
        let authSeq = '', isAuthPerson = false;
        if(!Array.isArray(resObj.ApplicantDtls)){ //check obj or array
            if(resObj.ApplicantDtls.IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum){
                authSeq = resObj.ApplicantDtls.ApplicantSeq;
                isAuthPerson = true;
            }
            else {  //non login user
                authSeq = '0';
                isAuthPerson = false;
            }
        }
        else { //array
            for(let i in resObj.ApplicantDtls) {
                if(resObj.ApplicantDtls[i].IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum) {  // get login user's seq number 
                    authSeq = resObj.ApplicantDtls[i].ApplicantSeq;
                    isAuthPerson = true;
                }
            }
        }

        if(isAuthPerson){
            return authSeq;
        }
        else {
            return '0';
        }
    }

    const filterCouOfResi = (fValue) =>{
        console.log('filterCouOfResi',fValue);
        let couArray = filterArray(countries, defCountry.value);
        return filterArray(couArray,fValue);
    }
    
    if(isLoading) {
        return(
            <Loading />
        )
    }

    return (
        <div className="container-fluid">
             <SubHeader />
             <FormContainer>
             <Form onSubmitClick={handleSubmit} 
                    initialValues={taxDetails}
                    key={JSON.stringify(taxDetails)}
                    render={(formRenderProps) => (
                    <FormElement>
                        <fieldset>
                            <Field component={FormTitle} id={'fst1'} 
                                name={taxData.formContainerTitle.T1.name} />

                            <Field component={FormSubTitle} id={'fstST1'} 
                                name={taxData.formSubTitle.ST1}   />

                            <FieldWrapper>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblCnOfTaxResi'} leftLabelName={taxData.label.cnOfTaxResi}
                                    id={'CnOfTaxResi'} name={taxDetails.CouOfTaxRes} />

                                <Field component={CusFormInput} 
                                    leftLabelId={'lblTIN'} leftLabelName={taxData.label.taxIN} 
                                    id={'TIN'} name={'TIN'} placeholder={'Please input'}  
                                    maxLength={20}
                                    validator={tinValidator} />

                                <CusRadioButton name="rdoPayTaxSGOnly" leftValue='Y' rightValue='N' 
                                    disabled={false} label={taxData.label.payTaxSGOnly} 
                                    onChange={e => {
                                        setPayTaxSGOnlySelected(e.value);
                                        formRenderProps.onChange('TaxNumber'+2, { value: '' });
                                        formRenderProps.onChange('CouOfTaxRes'+2, { value: '' });
                                        formRenderProps.onChange('AbleProvTIN'+2, { value: '' });
                                        formRenderProps.onChange('ReasonUnableProvTIN'+2 , { value: '' });
                                        couOfResiObj = {}

                                        setShowAddBtn(true); //hide show btn
                                        formRenderProps.onChange('TaxNumber'+3, { value: '' });
                                        formRenderProps.onChange('CouOfTaxRes'+3, { value: '' });
                                        formRenderProps.onChange('AbleProvTIN'+3, { value: '' });
                                        formRenderProps.onChange('ReasonUnableProvTIN'+3 , { value: '' });
                                        couOfResiObj3 = {}
                                    }} checkedValue={payTaxSGOnlySelected} />
                                {payTaxSGOnlySelected==='N'? 
                                <div>
                                <TaxResidence order={2} fProps={formRenderProps} 
                                    array={filterArray(countries,defCountry.value)}
                                    show={showReasonUnableProvTIN2()}
                                    onCouOfTaxResChange={v=>{
                                        if(v !== null){
                                            if(v.value === couOfResiObj3.value) {
                                                formRenderProps.onChange('CouOfTaxRes'+2, { value: '' });
                                                showErrMsg('Oops! Duplicate country found. Do remove one of the duplicate countries and re-try.')
                                                return;
                                            }
                                            couOfResiObj = v;
                                        }
                                    }}
                                    /> 
                                <FieldWrapper>
                                {showAddBtn? 
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span  
                                            onClick={ e => {
                                                e.preventDefault();
                                                if(formRenderProps.valueGetter('CouOfTaxRes'+2) === '' || formRenderProps.valueGetter('CouOfTaxRes'+2) === null || formRenderProps.valueGetter('CouOfTaxRes'+2) === undefined) {
                                                    showErrMsg('The business is also a tax resident of: Select drop down list')
                                                }
                                                else {
                                                    setShowAddBtn(false); //hide show btn
                                                }
                                            }}>
                                            <span className="k-icon k-i-plus-outline" style={{fontSize:'24px', marginRight:'10px', color:'grey'}}></span>
                                            <label>{taxData.label.addCntyBtn}</label>
                                        </span>
                                    </div>
                                </div> :
                                <div>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="box text-right" onClick={e=>{
                                       
                                            e.preventDefault();
                                            setShowAddBtn(true); //hide show btn
                                            formRenderProps.onChange('TaxNumber'+3, { value: '' });
                                            formRenderProps.onChange('CouOfTaxRes'+3, { value: '' });
                                            formRenderProps.onChange('AbleProvTIN'+3, { value: '' });
                                            formRenderProps.onChange('ReasonUnableProvTIN'+3 , { value: '' });
                                            couOfResiObj3 = {}
                                        }}>
                                            <label style={{marginRight:'10px'}}>REMOVE</label>
                                            <span className="k-icon k-i-delete" style={{fontSize:'24px', color:'grey'}}></span>
                                        </div>
                                    </div>
                                </div>

                                <TaxResidence order={3} fProps={formRenderProps} 
                                    array={filterArray(countries,defCountry.value)}
                                    show={showReasonUnableProvTIN3()}
                                    onCouOfTaxResChange={ v => {
                                        if(v !== null){
                                            if(v.value === couOfResiObj.value) {
                                                formRenderProps.onChange('CouOfTaxRes'+3, { value: '' });
                                                showErrMsg('Oops! Duplicate country found. Do remove one of the duplicate countries and re-try.')
                                                return;
                                            }
                                            couOfResiObj3 = v;
                                        }
                                    }} /> 
                                </div>
                                }
                                </FieldWrapper>
                                </div>
                                : null }
                             
                            </FieldWrapper>

                            <div style={{paddingTop: "10px"}}> <hr className="greyPanelLine" /> </div>

                            <Field component={FormSubTitle} id={'fstST3'} name={taxData.formSubTitle.ST3}   />
                          
                            <div className="row around-xs inputPair elementVisible" id={'fstST3VD'}>
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <a className="txtGray" href={taxData.crsViewDetails.hrefLink} target="_blank">{taxData.crsViewDetails.label}</a>
                                </div>
                            </div>
                      
                            <FieldWrapper>
                            <CusRadioButton name={'IsActiveBizEntity'} leftValue='Y' rightValue='N' 
                                disabled={false} label={taxData.label.csr} 
                                checkedValue={selectedIsActiveBizEntity} 
                                onChange={e => {
                                    setSelectedIsActiveBizEntity(e.value);
                                    formRenderProps.onChange('CRSStatus',{ value: '' });
                                }} />

                            <Field leftLabelId={'lblCRSStatus'} leftLabelName={taxData.label.csrStatus}
                                id={'CRSStatus'} name={'CRSStatus'}
                                component={CusFormComboBox}
                                textField={'label'}
                                data={getCRSStatusArray()}
                                placeholder={'Please select'}
                                validator={reqDDLValidator}
                                onChange={handleCRSStatus} /> 
                            </FieldWrapper>

                            <Field component={FormSubTitle} id={'fstST2'}  name={taxData.formSubTitle.ST2} />
                            <div className="row around-xs inputPair elementVisible" id={'fstST2VD'}>
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <a className="txtGray" href={taxData.fatcaViewDetails.hrefLink} target="_blank">{taxData.fatcaViewDetails.label}</a>
                                </div>
                            </div>

                            <FieldWrapper>
                            <Field leftLabelId={'lblFATCABIZ'} leftLabelName={taxData.label.fatcaStatus}
                                id={'FATCABIZ'} name={'FATCABIZ'}
                                component={CusFormComboBox}
                                textField={'label'}
                                data={taxData.fatcaBizStatus}
                                placeholder={'Please select'}
                                validator={reqDDLValidator}
                                onChange={handleFATCABiz} /> 
                            </FieldWrapper>
                            <FieldWrapper>
                            <CusRadioButton name={'FATCAUS'} leftValue='Y' rightValue='N' label={taxData.label.fatca} 
                                disabled={false} onChange={handleFATCAUSChange} checkedValue={selectedFATCAUS} />
                            </FieldWrapper>
                            <div style={{paddingTop: "10px"}}> <hr className="greyPanelLine" /> </div>

                            <Field component={FormTitle} id={'fst2'} name={taxData.formContainerTitle.T2.name} />

                            <Field name={'TaxClare'} label={taxData.terms}  id={'termsinput'}
                                component={TermsFormCheckboxNoErrMsgDisplay} validator={termsValidator} value={true}/>

                        <FieldWrapper>        
                        <CusProgressBar  bgcolor={item.bgcolor} completed={item.completed} /> 

                        <div className="row around-xs inputPair elementVisible" style={{ paddingBottom: "20px" }}>
                            <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <button className="btn btn-back" onClick={(e) => {  e.preventDefault(); history.push(config.route.NSDelegationDetails2)}}>{config.btnName.Back}</button>
                                <button type={'submit'} className="k-button btn btn-success btn-float-right" disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                            </div>
                        </div> 
                        </FieldWrapper>
                        {/* {isError && <CusNotification msg={errMsg} closable={true} status={'error'} 
                                onClose={()=>{ setIsError(false)}} />} */}

                        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} />
                               
                        </fieldset>
                    </FormElement>
                    )}>
             </Form>
             </FormContainer>
             {isSaving && <Loading />} 
        </div>
    )
}

export default NSTaxDetails